import { useTranslation } from "react-i18next";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "./button";

/**
 * Klassik "oldingi / keyingi" sahifalagich.
 *
 * Ledger sahifalaridagi "ko'proq yuklash" naqshidan farqli: u sana ustuniga
 * kiritilgan va to'plab boradi, bu esa mustaqil jadval uchun — o'qilgan
 * sahifani almashtiradi. Minglab satrli jurnalda to'plash xotirani ham,
 * scrollni ham ma'nosiz shishirardi.
 *
 * Yorliqlar `common` fazosida: sahifalagich bir necha bo'limda ishlatiladi,
 * shuning uchun matn bo'limga bog'lanmasligi kerak.
 */
export function Pagination({
  page,
  total,
  pageSize,
  onPage,
  disabled,
}: {
  page: number;
  total: number;
  pageSize: number;
  onPage: (page: number) => void;
  disabled?: boolean;
}) {
  const { t } = useTranslation("common");
  // Kamida 1 — 0 ta yozuvda "1 / 0" ko'rinmasin.
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  return (
    <div className="flex items-center justify-between gap-2 p-3 border-t text-sm text-muted-foreground">
      <span>{t("pagination.total", { total })}</span>
      <div className="flex items-center gap-2">
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => onPage(page - 1)}
          disabled={disabled || page <= 1}
        >
          <ChevronLeft />
          {t("pagination.prev")}
        </Button>
        <span className="tabular-nums px-2">
          {page} / {totalPages}
        </span>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => onPage(page + 1)}
          disabled={disabled || page >= totalPages}
        >
          {t("pagination.next")}
          <ChevronRight />
        </Button>
      </div>
    </div>
  );
}
